import React, { Component } from "react";
import {connect} from 'react-redux';
import RatingForm from "../Components/Orders/RatingForm";
import { orderService } from "../Services/OrderService.js";
import { withRouter } from 'react-router';


class RatingFormContainer extends Component {
	constructor(props){
		super(props);
		this.state={
			rating: null
		}
		this.updateRating = this.updateRating.bind(this);
		this.saveRating = this.saveRating.bind(this);
	}
	
	componentDidMount() {
		orderService.getRatingFromOrder(this.props.orderId)
					.then(response => {return this.setState({rating: response.data});})
					.catch(err => {/*console.log(err);*/});
	}

	updateRating(rating){
		this.setState({
			rating: {
						...this.state.rating,
						grammarortog: rating.grammarortog,
						localization: rating.localization,
						style: rating.style
					}
		});
	}
	
	saveRating(){
		orderService.setRating(this.state.rating.id, this.state.rating)
			.then(() => orderService.setState(this.state.rating.sample, 'FINISHED'))
			.then(() => {return this.props.history.push('/orderList')});
	}
	
	render() {
		if(this.state.rating==null){
			return <div>PROCESSING...</div>
		}else{
			return (<RatingForm	grammarortog={this.state.rating.grammarortog}
							localization={this.state.rating.localization}
							style={this.state.rating.style}
							update={this.updateRating}
							save={this.saveRating}/>);
		}
	}
}

function mapStateToProps(state, ownProps) {  
	return {orderId: ownProps.match.params.id, user: state.user}
}

export default connect(mapStateToProps)(RatingFormContainer);  